<template>
  <div class="message-template-text-content">
    <div class="phone-background">
      <b-row class="header-container">
        <b-col class="back-to-convos-container" cols="2">
          <ChevronLeft :size="20" />
          <span>3</span>
        </b-col>
        <b-col class="company-contact-container" cols="8">
          <div>
            <div>
              <b-img
                v-if="$store.getters.profile.organization.logo"
                :src="$store.getters.profile.organization.logo"
                class="logo"
              />
              <div v-else>
                <div class="logo">
                  {{ orgAbbreviation }}
                </div>
              </div>
            </div>
            <p>{{ $store.getters.profile.organization.name }}</p>
          </div>
        </b-col>
        <b-col class="info-container" cols="2">
          <span>i</span>
        </b-col>
      </b-row>
      <b-row class="convo-container">
        <div>
          <b-col>
            <p>Today {{ localTime }}</p>
            <div class="message-bubble">
              <div>{{ renderedBody }}</div>
            </div>
          </b-col>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script lang="ts">
import endpoints from '@/utils/endpoints'
import moment from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { ChevronLeft, ChevronRight } from 'lucide-vue'

interface MessageTemplate {
  sms_body: string
}

@Component({
  computed: {
    ...mapGetters(['profile'])
  },
  components: {
    ChevronLeft,
    ChevronRight
  }
})
export default class MessageTemplateText extends Vue {
  profile!: Record<string, any>

  @Prop({ type: Object }) readonly messageTemplate!: MessageTemplate
  invoiceLink = 'https://www.blytzpay.com/'
  renderedBody = 'Please save this template to view preview.'

  mounted() {
    if (this.$route.params.messageTemplateID) {
      this.renderTemplate()
    }
  }

  async renderTemplate() {
    const response = await this.axios.post(
      endpoints.randomRenderMessageTemplate(
        this.$route.params.merchantID,
        this.$route.params.messageTemplateID
      ),
      { message_template_body: this.smsBody, type: 'TEXT' }
    )
    this.renderedBody = response.data.rendered_body
  }

  get orgAbbreviation() {
    return this.$store.getters.profile.organization.name.charAt(0)
  }

  get localTime() {
    return moment().format('LT')
  }

  get customerName() {
    return this.profile.first_name ?? 'Customer'
  }

  get smsBody() {
    return this.messageTemplate.sms_body
      ? this.messageTemplate.sms_body
      : 'New Template content goes here!'
  }
}
</script>

<style lang="scss" scoped>
.message-template-text-content {
  display: flex;
  justify-content: center;
  height: 330px;
  margin-bottom: 2rem;
  overflow: hidden;

  .phone-background {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 430px;
    height: 330px;

    background-image: url('../../../assets/phone_preview.svg?url');
    background-repeat: no-repeat;

    .header-container {
      width: 100%;
      padding: 55px 40px 10px;

      .back-to-convos-container {
        display: flex;
        flex-direction: row;
        margin-top: 14px;
        padding-left: 10px;

        color: $bright-blue;
        font-size: 20px;

        span {
          display: block;
          width: 17px;
          height: 17px;
          margin: 1px 0 0 2px;
          padding: 0 0 2px;

          color: white;
          font-size: 12px;
          text-align: center;

          background-color: $bright-blue;
          border-radius: 50px;
        }
      }

      .company-contact-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 5px;

        div {
          display: flex;
          flex-direction: column;
          justify-content: center;

          div {
            display: flex;
            justify-content: center;

            .logo {
              display: inline-block;
              align-self: center;
              width: 40px;
              height: 40px;
              margin-top: 4px;

              color: white;
              font-size: 28px;
              text-align: center;

              background-color: $bright-blue;
              border-radius: 50%;
            }
          }

          p {
            margin: 0;

            font-size: 13px;
          }
        }
      }

      .info-container {
        display: flex;
        justify-content: flex-end;

        span {
          display: block;
          width: 20px;
          height: 20px;
          margin-top: 12px;

          color: $bright-blue;
          line-height: 20px;
          text-align: center;

          border: 1px solid $bright-blue;
          border-radius: 50px;
        }
      }
    }

    .convo-container {
      flex-basis: 70%;
      width: 100%;
      padding-bottom: 30px;
      overflow: auto;
      scrollbar-width: none;

      div.col {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        max-width: 430px;
        padding: 0 55px;

        p {
          margin: 10px;

          color: $light-gray;
          font-size: 10px;
          text-align: center;
        }

        .message-bubble {
          width: 80%;
          margin-bottom: 20px;
          padding: 5px 15px 12px;

          font-size: 0.9em;
          line-height: 20px;

          background-color: $main-bubble-bg;
          border-radius: 15px;
        }

        .message-bubble::before {
          position: absolute;
          bottom: 20px;
          left: 0;
          z-index: 0;

          width: 20px;
          height: 20px;
          margin-left: 45px;

          background: $main-bubble-bg;
          border-bottom-right-radius: 15px;

          content: '';
        }

        .message-bubble::after {
          position: absolute;
          bottom: 20px;
          left: 0;
          z-index: 1;

          width: 10px;
          height: 20px;
          margin-left: 45px;

          background: white;
          border-bottom-right-radius: 10px;

          content: '';
        }

        .message-bubble > pre {
          font-family: inherit;
        }
      }
    }

    .convo-container::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
